import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.css'

export class Modal {

    constructor ( target = '.js-modal', options = {} ) {
        this.target = $( target );
        this.options = {
            arrows: true,
            hash: false,
            animationEffect: 'fade',
            ...options
        }
    }

    init () {
        $( document ).ready( () => {
            this.modal = this.target.fancybox( this.options );
        } )
    }

}